export const StatementPaths = {
  SEARCH: '/statement/search',
  RESULTS: '/statement/results',
};
